module.exports = __webpack_public_path__ + "static/img/icon-email.3be4791e.png";